module.exports = __webpack_public_path__ + "static/media/tati.5a207900.ogg";